import { Domain } from '@gr/shared/entities';
import { IHttpResponse } from '@gr/shared/models';
import { useQuery } from '@tanstack/react-query';
import { axiosPost } from '../authAxios';

export default function useDomains() {
  return useQuery({
    queryKey: ['domains'],
    queryFn: async () => {
      const axios = await axiosPost<IHttpResponse<Domain[]>>('links-get-domains');
      return axios.data?.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
